import { createSlice } from "@reduxjs/toolkit";
import { TRANSLATION_STATE, VOICE_TYPES } from "../constants/AudioTranslationConstants";

const initialState = {
    translationEnabled: false,
    translationState: TRANSLATION_STATE.IDLE,
    sourceLanguage: "en-US",
    targetLanguage: "",
    targetLanguageCode: "",
    voiceType: VOICE_TYPES.FEMALE,
    isLanguageDrawerOpen: false,
    participantTranslationStatus: {},
    currentTranslatedText: "",
    currentOriginalText: "",
    translatedTextVisible: false,
    error: null,
    errorMessage: "",
};

const audioTranslationSlice = createSlice({
    name: "audioTranslation",
    initialState,
    reducers: {
        setTranslationEnabled(state, action) {
            state.translationEnabled = action.payload;
        },
        setTranslationState(state, action) {
            state.translationState = action.payload;
        },
        setSourceLanguage(state, action) {
            state.sourceLanguage = action.payload;
        },
        setTargetLanguage(state, action) {
            state.targetLanguage = action.payload;
        },
        setTargetLanguageCode(state, action) {
            state.targetLanguageCode = action.payload;
        },
        setVoiceType(state, action) {
            state.voiceType = action.payload;
        },
        setLanguageDrawerOpen(state, action) {
            state.isLanguageDrawerOpen = action.payload;
        },
        setParticipantTranslationStatus(state, action) {
            const { identity, status } = action.payload;
            state.participantTranslationStatus[identity] = status;
        },
        removeParticipantTranslationStatus(state, action) {
            delete state.participantTranslationStatus[action.payload];
        },
        setCurrentTranslatedText(state, action) {
            state.currentTranslatedText = action.payload;
        },
        setCurrentOriginalText(state, action) {
            state.currentOriginalText = action.payload;
        },
        setTranslatedTextVisible(state, action) {
            state.translatedTextVisible = action.payload;
        },
        setTranslationError(state, action) {
            state.error = action.payload;
            state.translationState = TRANSLATION_STATE.ERROR;
            state.errorMessage = action.payload?.message || "Translation error occurred";
        },
        clearTranslationError(state) {
            state.error = null;
            state.errorMessage = "";
            if (state.translationState === TRANSLATION_STATE.ERROR) {
                state.translationState = TRANSLATION_STATE.IDLE;
            }
        },
        resetAudioTranslationReducer() {
            return initialState;
        },
    },
});

export const {
    setTranslationEnabled,
    setTranslationState,
    setSourceLanguage,
    setTargetLanguage,
    setTargetLanguageCode,
    setVoiceType,
    setLanguageDrawerOpen,
    setParticipantTranslationStatus,
    removeParticipantTranslationStatus,
    setCurrentTranslatedText,
    setCurrentOriginalText,
    setTranslatedTextVisible,
    setTranslationError,
    clearTranslationError,
    resetAudioTranslationReducer,
} = audioTranslationSlice.actions;

export default audioTranslationSlice.reducer;
